module.exports = __webpack_public_path__ + "static/media/diprospero.e3b29099.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/mildiu_pepino/curativa/diprospero.png
// module id = 2109
// module chunks = 3